import React from "react";
import { formatDateTime, formatMoney, getPayoutMethodLabel, getStatusBadgeClass, getStatusLabel } from "./utils";

export default function WithdrawalHistory({ earnings, isAr, isMobile }) {
  const { requests } = earnings;

  return (
    <div className="card border-0 shadow-sm mb-4 provider-center__panel-card pc-panel--history">
      <div className="card-body">
        <div className="pc-section-head mb-3">
          <div className="pc-section-head__left">
            <span className="pc-icon-box pc-icon-box--slate"><i className="bi bi-clock-history" /></span>
            <h5 className="mb-0">{isAr ? "طلبات السحب" : "Withdrawal Requests"}</h5>
          </div>
          <span className="badge text-bg-light">{requests.length}</span>
        </div>

        {requests.length === 0 ? (
          <div className="text-muted small">
            {isAr ? "لا توجد طلبات سحب حتى الآن." : "No withdrawal requests yet."}
          </div>
        ) : isMobile ? (
          <div className="provider-center__mobile-list">
            {requests.map((request) => (
              <article className="provider-center__mobile-item" key={request.id}>
                <div className="provider-center__mobile-head">
                  <div>
                    <div className="fw-semibold">
                      {formatMoney(request.amount, request.currency)}
                    </div>
                    <div className="small text-muted">
                      {getPayoutMethodLabel(
                        request.withdrawalMethod || request.payoutMethod?.method,
                        isAr,
                      )}
                    </div>
                  </div>
                  <span className={`badge rounded-pill ${getStatusBadgeClass(request.status)}`}>
                    {getStatusLabel(request.status, isAr)}
                  </span>
                </div>
                <div className="provider-center__mobile-grid">
                  <div>
                    <div className="small text-muted">{isAr ? "الوجهة" : "Destination"}</div>
                    <div>
                      {request.bankAccount?.iban ||
                        request.payoutMethod?.destinationEmail ||
                        request.payoutMethod?.destinationReference ||
                        request.destinationSnapshot?.iban ||
                        request.destinationSnapshot?.destination_email ||
                        "-"}
                    </div>
                  </div>
                  <div>
                    <div className="small text-muted">{isAr ? "التاريخ" : "Date"}</div>
                    <div>{formatDateTime(request.createdAt)}</div>
                  </div>
                </div>
                {request.providerStatus ? (
                  <div className="small text-muted mt-2">
                    {isAr ? "حالة المزود:" : "Provider:"} {request.providerStatus}
                  </div>
                ) : null}
                {request.reviewReason ? (
                  <div className="small text-muted mt-2">{request.reviewReason}</div>
                ) : null}
                {request.failureReason ? (
                  <div className="small text-danger mt-2">{request.failureReason}</div>
                ) : null}
                {request.rejectionReason ? (
                  <div className="small text-danger mt-2">{request.rejectionReason}</div>
                ) : null}
              </article>
            ))}
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table align-middle mb-0">
              <thead>
                <tr>
                  <th>{isAr ? "المبلغ" : "Amount"}</th>
                  <th>{isAr ? "الطريقة" : "Method"}</th>
                  <th>{isAr ? "الحالة" : "Status"}</th>
                  <th>{isAr ? "التاريخ" : "Date"}</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((request) => (
                  <tr key={request.id}>
                    <td>{formatMoney(request.amount, request.currency)}</td>
                    <td>
                      <div className="fw-semibold">
                        {getPayoutMethodLabel(
                          request.withdrawalMethod || request.payoutMethod?.method,
                          isAr,
                        )}
                      </div>
                      <div className="small text-muted">
                        {request.bankAccount?.iban ||
                          request.payoutMethod?.destinationEmail ||
                          request.payoutMethod?.destinationReference ||
                          request.destinationSnapshot?.iban ||
                          request.destinationSnapshot?.destination_email ||
                          "-"}
                      </div>
                    </td>
                    <td>
                      <span className={`badge rounded-pill ${getStatusBadgeClass(request.status)}`}>
                        {getStatusLabel(request.status, isAr)}
                      </span>
                      {request.providerStatus ? (
                        <div className="small text-muted mt-1">
                          {isAr ? "حالة المزود:" : "Provider:"} {request.providerStatus}
                        </div>
                      ) : null}
                      {request.reviewReason ? (
                        <div className="small text-muted mt-1">{request.reviewReason}</div>
                      ) : null}
                      {request.failureReason ? (
                        <div className="small text-danger mt-1">{request.failureReason}</div>
                      ) : null}
                      {request.rejectionReason ? (
                        <div className="small text-danger mt-1">{request.rejectionReason}</div>
                      ) : null}
                    </td>
                    <td>{formatDateTime(request.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
